
import React from "react";

const Section = ({ title, content, children }) => (
  <div
    style={{
      backgroundColor: "#f9fafb",
      padding: "1.5rem",
      borderRadius: "0.5rem",
      marginBottom: "2rem",
      boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
    }}
  >
    <h2
      style={{
        color: "#1e3a8a",
        marginBottom: "1rem",
        fontSize: "1.25rem",
        fontWeight: "600",
      }}
    >
      {title}
    </h2>
    {content && <p style={{ color: "#374151" }}>{content}</p>}
    {children}
  </div>
);

const SubSection = ({ number, title, items }) => (
  <div style={{ marginBottom: "1.5rem" }}>
    <h3 style={{ fontWeight: "600", marginBottom: "0.75rem" }}>
      {number}. {title}
    </h3>
    <ul style={{ paddingLeft: "1.5rem", listStyleType: "decimal" }}>
      {items.map((item, index) => (
        <li key={index} style={{ color: "#374151", marginBottom: "0.5rem" }}>
          {number}.{index + 1} {item}
        </li>
      ))}
    </ul>
  </div>
);

const termsData = {
  companyName: "Bombay Dental Company",
  effectiveDate: "01/01/2025",
  email: "bombaydentalcompany@gmail.com",
  introduction: "By availing of our services, you agree to abide by the following terms and conditions:",
  sections: [
    {
      number: 1,
      title: "Appointments & Consultations",
      items: [
        "Patients are encouraged to book appointments in advance to avoid long wait times.",
        "Walk-in patients will be accommodated based on availability.",
        "If you need to reschedule or cancel an appointment, kindly inform us at least 24 hours in advance."
      ]
    },
    {
      number: 2,
      title: "Treatment & Consent",
      items: [
        "Before undergoing any dental procedure, you will receive a detailed explanation of the treatment, risks, and expected outcomes.",
        "Your consent is mandatory before proceeding with any treatment.",
        "In case of minors (below 18 years), consent must be provided by a parent or legal guardian."
      ]
    },
    {
      number: 3,
      title: "Payment & Fees",
      items: [
        "All payments must be made at the time of service unless agreed otherwise.",
        "We accept cash, credit/debit cards, UPI, and online payments.",
        "For long-term treatments (e.g., orthodontics, implants), a structured payment plan may be available.",
        "Any unpaid dues must be cleared before the completion of treatment."
      ]
    },
    {
      number: 4,
      title: "Refund & Cancellation Policy",
      items: [
        "Consultation fees are non-refundable.",
        "Prepaid treatments or procedures are non-refundable but may be adjusted against other services if the treatment has not started.",
        "If a patient misses an appointment without prior notice, any advance payment made will be forfeited."
      ]
    },
    {
      number: 5,
      title: "Confidentiality & Data Protection",
      items: [
        "All patient records and personal information are strictly confidential.",
        "We comply with applicable data protection laws and will not share your details without consent, except when required by law.",
        "Digital records, including X-rays and treatment history, will be securely stored for future reference."
      ]
    },
    {
      number: 6,
      title: "Hygiene & Safety",
      items: [
        "We follow strict sterilization and hygiene protocols to ensure patient safety.",
        "Patients experiencing cold, flu, or any contagious illness are advised to inform the clinic before their appointment."
      ]
    },
    {
      number: 7,
      title: "Medical Emergencies",
      items: [
        "In case of a dental emergency, please contact the clinic immediately for priority scheduling.",
        "If the clinic is closed, we advise seeking assistance at the nearest hospital or emergency dental service."
      ]
    },
    {
      number: 8,
      title: "Warranty & Liability",
      items: [
        "Dental treatments, including crowns, bridges, and implants, may come with specific warranties based on material and manufacturer terms.",
        "The clinic is not responsible for treatment failure due to patient non-compliance, poor oral hygiene, or external factors."
      ]
    },
    {
      number: 9,
      title: "Code of Conduct",
      items: [
        "We expect respectful behavior from all patients. Any form of verbal or physical abuse towards staff or other patients will not be tolerated.",
        "The clinic reserves the right to refuse treatment to anyone exhibiting inappropriate conduct."
      ]
    },
    {
      number: 10,
      title: "Amendments to Terms & Conditions",
      items: [
        "These terms may be updated periodically without prior notice. The latest version will always be available at the clinic or on our website."
      ]
    }
  ]
};

export default function TermsandCondition() {
  return (
    <div
      style={{
        fontFamily: "sans-serif",
        maxWidth: "64rem",
        margin: "0 auto",
        padding: "2rem",
        color: "#4a5568",
        lineHeight: "1.625",
      }}
    >
      <h1
        style={{
          fontSize: "1.875rem",
          color: "#1e3a8a",
          textAlign: "center",
          marginBottom: "1rem",
          fontWeight: "bold",
        }}
      >
        Terms & Conditions for {termsData.companyName}
      </h1>

      <p
        style={{
          textAlign: "center",
          marginBottom: "2.5rem",
          color: "#718096",
        }}
      >
        Effective Date: {termsData.effectiveDate}
      </p>

      <Section content={termsData.introduction} />

      {termsData.sections.map((section) => (
        <Section key={section.number}>
          <SubSection
            number={section.number}
            title={section.title}
            items={section.items}
          />
        </Section>
      ))}

      <Section>
        <p style={{ marginBottom: "1rem" }}>
          By availing services at {termsData.companyName}, you acknowledge that
          you have read, understood, and agreed to these Terms & Conditions.
        </p>
        <p>
          For any queries, please contact us at:{" "}
          <a
            href={`mailto:${termsData.email}`}
            style={{
              color: "#2563eb",
              textDecoration: "none",
            }}
            onMouseOver={(e) => (e.target.style.color = "#1e40af")}
            onMouseOut={(e) => (e.target.style.color = "#2563eb")}
          >
            {termsData.email}
          </a>
        </p>
      </Section>
    </div>
  );
}
